import React from 'react'
import { object, string, oneOfType } from 'prop-types'
import { css } from '@emotion/react'
import Star from '../../../../assets/icons/star.inline.svg'
import mediaQueries from '../../../../layout/media-queries'
import Logo from './Logo'

const campaignAppName = (isMainCampaign) => (theme) =>
  css`
    margin-bottom: 8px;

    ${mediaQueries.xsmallScreen(200)} {
      margin-bottom: 24px;
    }

    ${mediaQueries.mediumScreen()} {
      margin-bottom: ${isMainCampaign ? '24px' : '20px'};
    }

    > div {
      display: flex;
      align-items: center;
      margin-bottom: 6px;

      > span {
        font-size: 13px;
        font-weight: 700;
        color: ${theme.colors.rose};
        letter-spacing: 0.005em;
        margin-left: 10px;
      }
    }
  `

const starCss = (theme) => css`
  fill: ${theme.colors.rose};
`

const AppName = ({ campaign, promoLabel }) => {
  if (!campaign) {
    return null
  }

  return (
    <div data-test={`title-${campaign.id}`} css={campaignAppName(!!promoLabel)}>
      {promoLabel && (
        <div>
          {promoLabel?.icon || <Star css={starCss} />}
          <span>{promoLabel?.label || promoLabel}</span>
        </div>
      )}
      <Logo campaign={campaign} />
    </div>
  )
}

AppName.propTypes = {
  campaign: object,
  promoLabel: oneOfType([object, string]),
}

export default AppName
